export default "__VITE_PUBLIC_ASSET__71a27171__"